var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisibilityOutlineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98657 4.875C6.94241 4.875 3.81907 6.6375 1.36074 10.1617C1.29051 10.2633 1.252 10.3836 1.25008 10.5071C1.24815 10.6307 1.28289 10.752 1.34991 10.8558C3.23907 13.8125 6.31991 16.125 9.98657 16.125C13.6132 16.125 16.7574 13.8058 18.6507 10.8417C18.7162 10.7399 18.751 10.6214 18.751 10.5004C18.751 10.3794 18.7162 10.2609 18.6507 10.1592C16.7532 7.23 13.5857 4.875 9.98657 4.875Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.625C10.8288 13.625 11.6237 13.2958 12.2097 12.7097C12.7958 12.1237 13.125 11.3288 13.125 10.5C13.125 9.6712 12.7958 8.87634 12.2097 8.29029C11.6237 7.70424 10.8288 7.375 10 7.375C9.1712 7.375 8.37634 7.70424 7.79029 8.29029C7.20424 8.87634 6.875 9.6712 6.875 10.5C6.875 11.3288 7.20424 12.1237 7.79029 12.7097C8.37634 13.2958 9.1712 13.625 10 13.625Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOutlineIcon);
export default __webpack_public_path__ + "static/media/VisibilityOutlineIcon.fca866d6ece83759e56e6d12f29d306e.svg";
export { ForwardRef as ReactComponent };